import { render, staticRenderFns } from "./InvoiceForm.vue?vue&type=template&id=117395a4&scoped=true&"
import script from "./InvoiceForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117395a4",
  null
  
)

export default component.exports